module.exports = __webpack_public_path__ + "img/icon-error@2x.ca3d15c0.png";